import React from 'react';
import { format } from 'date-fns';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Wrapper = styled.time`
  display: inline-block;
  padding: 1px 3px;
  border-radius: 4px;
  text-transform: uppercase;
  font-size: 12px;

  ${(p) =>
    p.theme.mode === 'light'
      ? `
      color: ${p.theme.colors.lightText};
      background-color: ${p.theme.colors.grey95};
    `
      : `
      color: ${p.theme.colors.grey85};
      background-color: ${p.theme.colors.grey35};
    `}

  ${(p) =>
    p.color === 'yellow' &&
    (p.theme.mode === 'light'
      ? `
    color: ${p.theme.colors.yellow45};
    background-color: ${p.theme.colors.yellow95};
  `
      : `
    color: ${p.theme.colors.yellow85};
    background-color: ${p.theme.colors.yellow25};
  `)}

  ${(p) =>
    p.color === 'blue' &&
    (p.theme.mode === 'light'
      ? `
      color: ${p.theme.colors.blue};
      background-color: ${p.theme.colors.blue95};
    `
      : `
      color: ${p.theme.colors.blue85};
      background-color: ${p.theme.colors.blue25};
    `)}

  ${(p) =>
    p.color === 'red' &&
    (p.theme.mode === 'light'
      ? `
      color: ${p.theme.colors.red};
      background-color: ${p.theme.colors.red95};
    `
      : `
      color: ${p.theme.colors.red85};
      background-color: ${p.theme.colors.red25};
    `)}

  ${(p) =>
    p.color === 'green' &&
    (p.theme.mode === 'light'
      ? `
      color: ${p.theme.colors.green};
      background-color: ${p.theme.colors.green95};
    `
      : `
      color: ${p.theme.colors.green85};
      background-color: ${p.theme.colors.green25};
    `)}
`;

const formatTimestamp = (ts, isHistorical) => {
  if (!ts) {
    return '';
  }

  if (isHistorical) {
    return format(new Date(ts), 'dd.MM.yyyy');
  }
  return format(new Date(ts), 'dd.MM.yyyy, HH') + ' Uhr';
};

function TimeStamp({ timestamp, isHistorical, ...props }) {
  const formattedValue = formatTimestamp(timestamp, isHistorical);

  return (
    <Wrapper color={isHistorical ? 'grey' : 'yellow'} {...props}>
      Stand: <strong>{formattedValue}</strong>
    </Wrapper>
  );
}

TimeStamp.propTypes = {
  timestamp: PropTypes.number,
  isHistorical: PropTypes.bool,
};

TimeStamp.defaultProps = {
  isHistorical: false,
};

export default TimeStamp;
